export default __webpack_public_path__ + "static/media/background.cc8f874a.png";